export default __webpack_public_path__ + "static/media/hero-block-1.7ddd3eeb.svg";